import {
  type AuditLogRenderer,
  formatAuditSubjectDescription,
} from '@core/utils/auditLog';

export const renderEntityDuplicated: AuditLogRenderer = (entry) => {
  const { typeLabel, idPart } = formatAuditSubjectDescription(entry);
  const sourceItemId = entry.metadata?.sourceItemId;
  const sourceIdPart =
    typeof sourceItemId === 'number' ? ` #${sourceItemId}` : '';

  return (
    <>
      {typeLabel}
      {idPart} duplicated from {typeLabel}
      {sourceIdPart}
    </>
  );
};
